export default __webpack_public_path__ + "static/media/src_convert7776_mobile_4.b43d54c6.jpg";